import { S101gS101m01Component } from './s101g-s101m01.component';

export { S101gModule } from './s101g.module';

export const S101gSubComponentsMap = {
	
};

export const S101gComponentsMap = {
	"s101g-s101m01": S101gS101m01Component
};

export const S101gComponents = [
	S101gS101m01Component
];

